export const enum EPaymentStatus {
  Successful = 'successful',
}
